export const routes = {
    LOGIN: "/",
    PROFILE: "/profile",
    GROUNDS: "/grounds",
    GROUND_CREATE: "/grounds/create",
    GROUND_DETAIL: "/grounds/:id",
    SLOTS: "/slots",
    SLOT_CREATE: "/slots/create",
    SLOT_DETAIL: "/slots/:id",
    BOOKINGS: "/bookings",
    BOOKING_DETAIL: "/bookings/:id",
    EARNINGS: "/earnings",
    WITHDRAW_REQUEST: "/withdraw",
    NOTIFICATIONS: "/notifications",
    OFFLINE_BOOKING: "/offline-booking",
    OFFLINE_BOOKING_CREATE: "/offline-booking/create",
    CHANGE_PASSWORD: "/change-password",
    USERS: "/users",
    USER_CREATE: "/users/create",
    USER_DETAIL: "/users/:id",
    ROLES: "/roles",
    ROLE_CREATE: "/roles/create",
    ROLE_DETAIL: "/roles/:id",
    APPROVAL: "/approval",
    REPORTS: "/reports",
    REPORT_DETAIL: "/reports/:id",
    ANALYTICS: "/analytics",
    MAINTENANCE: "/maintenance",
    MAINTENANCE_CREATE: "/maintenance/create",
    MAINTENANCE_DETAIL: "/maintenance/:id",
    CALENDAR: "/calendar",
    ADMIN_WITHDRAWALS: "/admin/withdrawals",
};
